import { createUseStyles } from 'react-jss';

import { FontWeight, ITheme, mediaQuery } from '../../../styles';

import IFormatIcon, { FormatIconFormatBg, FormatIconFormatBorderColor } from './types';

const useStyles = createUseStyles<string, IFormatIcon>(
  ({ breakpoints }: ITheme) => ({
    note: {
      backgroundColor: ({ format }) => (format ? FormatIconFormatBg[format] : '#000'),
      display: 'flex',
      justifyContent: 'center',
      position: 'relative',
      color: '#fff',
      textTransform: 'uppercase',
      fontWeight: FontWeight.ExtraBold,
      userSelect: 'none',
      alignItems: 'center',

      '&:before': {
        backgroundColor: ({ format }) => FormatIconFormatBorderColor[format],
        borderColor: ({ foldBg }) => `${foldBg} ${foldBg} transparent transparent`,

        content: '""',
        position: 'absolute',
        top: '0',
        right: '0',
        borderStyle: 'solid',
        display: 'block',
        width: '0',
        height: '0',
        zIndex: '10',
      },

      '&.small': {
        width: '28px',
        height: '32px',
        borderRadius: '3px',
        fontSize: '8px',

        '&:before': {
          borderWidth: '0 10px 10px 0',
        },

        '&.rounded:before': {
          borderRadius: '0 0 0 3px',
        },
      },

      '&.medium': {
        minWidth: 40,
        height: 46,
        borderRadius: 4,
        fontSize: 11,

        '&:before': {
          borderWidth: '0 14px 14px 0',
        },

        '&.rounded:before': {
          borderRadius: '0 0 0 4px',
        },

        [mediaQuery(breakpoints.mobile)]: {
          minWidth: 32,
          height: 36,
          fontSize: 10,
        },
      },

      '&.large': {
        width: '62px',
        height: '85px',
        borderRadius: '5px',
        fontSize: '19px',

        '& > div': {
          marginTop: '3px',
        },

        '&:before': {
          borderWidth: '0 22px 22px 0',
        },

        '&.rounded:before': {
          borderRadius: '0 0 0 5px',
        },
      },
    },
  }),
  { name: 'format-icon' },
);

export default useStyles;
